import { GitCompare, Info } from 'lucide-react';
import { Card } from '../ui/card';
import { formatEuro, STATUS_META, statusMeta } from '../../lib/taxFlow';

const ORDER = ['a_verifier', 'a_supprimer', 'nouveau', 'document_manquant', 'identique'];

// Comparaison N−1 / N : un statut par élément, les montants N−1 restent une référence.
export const ComparisonView = ({ comparison, isDark }) => {
  if (!comparison) return null;
  const n = comparison.annee_revenus;
  const n1 = comparison.annee_revenus_n1;
  const sorted = [...comparison.items].sort((a, b) => ORDER.indexOf(a.status) - ORDER.indexOf(b.status));

  return (
    <div data-testid="comparison-view">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-6">
        {ORDER.map((s) => (
          <div key={s} className={`p-3 rounded-xl border text-center ${isDark ? 'bg-white/[0.04] border-white/10' : 'bg-white border-black/5'}`} data-testid={`comparison-count-${s}`}>
            <div className="text-2xl font-light" style={{ color: STATUS_META[s].color }}>{comparison.counts[s] || 0}</div>
            <div className="text-[10px] uppercase tracking-widest opacity-60">{STATUS_META[s].label}</div>
          </div>
        ))}
      </div>

      {!comparison.n1_available && (
        <Card className={`${isDark ? '' : 'text-[#1d1d1f] '}p-4 mb-4 border ${isDark ? 'bg-white/[0.03] border-white/10' : 'bg-black/[0.02] border-black/5'}`}>
          <div className="flex gap-2 text-xs opacity-80">
            <Info className="w-4 h-4 flex-shrink-0" />
            {comparison.profil_declarant === 'premiere'
              ? 'Première déclaration : pas de comparaison avec une année précédente, tout est nouveau.'
              : `Aucun avis d'imposition sur les revenus ${n1} importé : la comparaison reste partielle.`}
          </div>
        </Card>
      )}
      {comparison.n1_is_parents && (
        <Card className={`${isDark ? '' : 'text-[#1d1d1f] '}p-4 mb-4 border ${isDark ? 'bg-white/[0.03] border-white/10' : 'bg-black/[0.02] border-black/5'}`}>
          <div className="flex gap-2 text-xs opacity-80">
            <Info className="w-4 h-4 flex-shrink-0" />
            La référence {n1} est la déclaration de tes parents : elle sert de repère, mais ta déclaration {n} est la tienne.
          </div>
        </Card>
      )}

      <div className="space-y-2">
        {sorted.map((r) => {
          const meta = statusMeta(r.status);
          return (
            <div
              key={`${r.topic}-${r.kind}`}
              data-testid={`comparison-${r.topic}-${r.kind}`}
              className={`p-4 rounded-xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-white border-black/5'}`}
            >
              <div className="flex items-start gap-3 flex-wrap">
                <GitCompare className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: meta.color }} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-baseline gap-2 flex-wrap mb-1">
                    <span className="font-medium text-sm">{r.title}</span>
                    <span className="text-[10px] uppercase tracking-widest px-1.5 py-0.5 rounded" style={{ color: meta.color, background: `${meta.color}22` }}>
                      {meta.label}
                    </span>
                    {r.prefilled && <span className="text-[10px] uppercase tracking-widest opacity-60">Prérempli</span>}
                  </div>
                  <div className="text-xs opacity-70">{r.reason}</div>
                  {(r.n1_value !== null || r.n_value !== null) && r.kind === 'case' && (
                    <div className="flex gap-4 mt-2 text-[11px]">
                      <span><span className="opacity-60">Revenus {n1} :</span> <strong>{typeof r.n1_value === 'string' ? r.n1_value : formatEuro(r.n1_value)}</strong></span>
                      <span><span className="opacity-60">Revenus {n} :</span> <strong>{typeof r.n_value === 'string' ? r.n_value : formatEuro(r.n_value)}</strong></span>
                    </div>
                  )}
                  {r.cases_n1 && r.cases_n1.length > 0 && (
                    <div className="text-[11px] opacity-60 mt-1">Cases {n1} : {r.cases_n1.join(', ')}</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComparisonView;
